// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__1oM-v","tab":"UserNav_tab__28xQ7"};